<script lang="ts">
import { Component } from 'vue-property-decorator'
import ButtonSmall from './ButtonSmall.vue'

@Component({ name: 'ButtonNormal' })
export default class ButtonMedium extends ButtonSmall {
  size = 'is-normal'
}
</script>
